import React from 'react';
import { useDispatch } from 'react-redux';
import './HmiHATApp.scss';
import logo from '../../assets/icons/hat-data-rights-icon.svg';
import { setDirectSignupTermsAgreed } from '../directSignup/directSignupSlice';
import { incrementBaasStep } from '../baasSignup/baasSignupSlice';
import { incrementDaasStep } from '../daasSignup/daasSignupSlice';
import { HmiType } from './hmi.interface';

type Props = {
  hmiType: HmiType;
};

export const HmiHATApp: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  return (
    <div className={'hatters-flex-column-container hmi-hat-owner-screen-container'}>
      <img
        className={'hmi-data-rights-img'}
        style={{ marginBottom: '0' }}
        src={logo}
        alt={'HAT Data rights protected'}
      />

      <div className={'hmi-hat-owner-hat-app hmi-text-grey'}>
        The HAT app is your dashboard and viewer of your HAT Personal Data Account in the cloud. This HAT app is
        provided as part of the HAT PDA.
        <br /> <br />
        With the HAT app, you can:
      </div>

      <div className={'hmi-hat-owner-white-box'}>
        <ul className="instruction-list">
          <li className="list-item" dangerouslySetInnerHTML={{ __html: 'view your HAT data' }} />
          <li
            className="list-item"
            dangerouslySetInnerHTML={{
              __html: 'Manage applications that you have signed on to with your HAT',
            }}
          />
        </ul>
      </div>

      <span className={'flex-spacer-small'} />

      <button
        className="hatters-btn hatters-btn-accent"
        onClick={() => {
          if (props.hmiType === HmiType.hatDirect) {
            dispatch(setDirectSignupTermsAgreed());
          } else if (props.hmiType === HmiType.baas) {
            dispatch(incrementBaasStep(2));
          } else if (props.hmiType === HmiType.daas) {
            dispatch(incrementDaasStep(1));
          }
        }}
      >
        OK
      </button>

      <span className={'flex-spacer-small'} />
    </div>
  );
};
